import { render, staticRenderFns } from "./BookCarousel.vue?vue&type=template&id=146d6044&"
import script from "./BookCarousel.vue?vue&type=script&lang=js&"
export * from "./BookCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports